module.exports = __webpack_public_path__ + "img/selected5-min.862d9e83.png";